import gazetteer, { type CountryCodes, type Market } from '@bridebook/toolbox/src/gazetteer';

const availabilityByCountry = new Map<string, boolean>();

/**
 * Whether the planner is on in the wedding's market, from the market settings with country
 * overrides. The knowledge base is UK-only, so a market needs its own before it is turned on.
 * Checked on the client only; nothing sensitive sits behind it.
 *
 * Keep the imports client-safe: the global page shell reads this, so imports land in every
 * page's bundle.
 */
export const isPlannerAvailableForCountry = (country: string | null | undefined): boolean => {
  if (!country) return false;

  // Reading settings merges the whole bucket, so cache the answer per country.
  const cached = availabilityByCountry.get(country);
  if (cached !== undefined) return cached;

  let market: Market | undefined;
  try {
    market = gazetteer.getMarketByCountry(country as CountryCodes);
  } catch {
    // An unknown country has no market to read the setting from.
  }

  const isAvailable = market?.getSetting('aiWeddingPlanner') === true;
  availabilityByCountry.set(country, isAvailable);
  return isAvailable;
};

// The launch A/B test: control has no planner, both variants have it. The server reads it too.
export const AI_WEDDING_PLANNER_TEST_ID = 'LIVE-28398_AiWeddingPlanner';

export const isAiWeddingPlannerVariantEnabled = (variant: string | null | undefined): boolean =>
  variant === '1' || variant === '2';
